import http from '../utils/https';

//产品信息接口
export function getProductList(params) {
	return http.post({
		url: '/api/product/product/frontList',
		params
	});
}

//新闻内容接口
export function getNewsList(params) {
	return http.post({
		url: '/api/news/content/frontList',
		params
	});
}

// 获取新闻详情页
export function getNewsDetail(id) {
	return http.get(`/api/news/content/ajavView/${id}`);
}

//集团荣誉接口
export function getHonorList() {
	return http.post({
		url: '/api/honor/honor/frontList'
	});
}

// 领导关怀图片列表
export function getLeaderImageList({ type, language }) {
	return http.post({
		url: '/api/image/image/frontList',
		params: { type, language }
	});
}

// 领导关怀图片详情列表
export function getLeaderDetailImageList(id) {
	return http.post({
		url: '/api/image/image/imageList',
		params: {
			businessImageId: id,
			type: 'SJ'
		}
	});
}

// 里程碑接口
export function getMilepostList() {
	return http.post({
		url: '/api/milepost/milepost/frontList'
	});
}

// 里程碑接口
export function getVideoList({ type, language }) {
	return http.post({
		url: '/api/video/video/frontList',
		params: { type, language }
	});
}
